import React, { memo, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import { Cfm, Icon, Web } from './logos';

import styles from '../styles/LogoSidebar';
const useStyles = createUseStyles(styles, 'LogoSidebar');

const LogoSidebar = memo(
    ({ appName, className: classNameProp, customLogo, homeLink = '/', isExpanded = true }) => {
        const classes = useStyles();

        const rootClassName = classnames(
            classes.root,
            {
                [classes.isExpanded]: isExpanded,
            },
            classNameProp,
        );

        const getLogo = useCallback(
            (appName, logoProps) =>
                ({
                    cfm: <Cfm {...logoProps} />,
                    web: <Web {...logoProps} />,
                })[appName],
            [],
        );

        const rectangularProps = useMemo(() => {
            const rectangularClass =
                appName === 'web' ? classes.rectangularFM : classes.rectangularAdmin;
            return {
                className: rectangularClass,
            };
        }, [appName, classes]);

        const square = useMemo(() => {
            if (customLogo?.square) {
                return (
                    <div
                        style={{ backgroundImage: `url('${customLogo.square}'` }}
                        className={classes.customSquare}
                    />
                );
            }
            return <Icon />;
        }, [classes.customSquare, customLogo]);

        const rectangular = useMemo(() => {
            if (customLogo?.rectangular) {
                return (
                    <div
                        style={{ backgroundImage: `url('${customLogo.rectangular}'` }}
                        className={classes.customRectangular}
                    />
                );
            }
            return getLogo(appName, rectangularProps);
        }, [appName, classes.customRectangular, customLogo, getLogo, rectangularProps]);

        return (
            <a href={homeLink} className={rootClassName}>
                {square}
                {rectangular}
            </a>
        );
    },
);

LogoSidebar.propTypes = {
    appName: PropTypes.oneOf(['web', 'cfm']).isRequired,
    className: PropTypes.string,
    homeLink: PropTypes.string,
    isExpanded: PropTypes.bool,
};

export default LogoSidebar;
